import React from "react";
import { Image } from "react-bootstrap";
import imgFameFamirea from "../../../images/commun/Fame_par_Famirea.png";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className="row col-xs-12 col-lg-10 mx-auto mt-4">
      <div className="col-12 col-md-5 text-center">
        <Image
          fluid
          src={imgFameFamirea}
          alt="Logos Fame et Famirea"
          className={styles.logos}
        />
      </div>
      <div className="col-12 col-md-2 d-flex text-center align-items-center justify-content-center">
        © 2024 FAMIREA
      </div>
    </footer>
  );
};

export default Footer;
